module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.view.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.purchase.view.details'),
      "name": "first"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.purchase.view.detailsLegend')))]), _vm._v(" "), [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.code')) + ": \n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n\t\t\t\t                        " + _vm._s(_vm.currentPurchase.code) + " \n\t\t\t\t                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.supplier')) + ": \n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'supplier.edit',
        params: {
          id: _vm.currentPurchase.supplier.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.currentPurchase.supplier.name))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.warehouse')) + ": \n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'warehouse.edit',
        params: {
          id: _vm.currentPurchase.warehouse.id
        }
      }
    }
  }, [_vm._v("\n\t\t\t\t                        " + _vm._s(_vm.currentPurchase.warehouse.name) + "\n\t\t\t\t                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.qty')) + ": \n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n\t\t\t\t                        " + _vm._s(_vm.currentPurchase.total_qty) + "\n\t\t\t\t                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.comments')) + ": \n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n\t\t\t\t                        " + _vm._s(_vm.currentPurchase.comments) + "\n\t\t\t\t                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.createdAt')) + ": \n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n\t\t\t\t                        " + _vm._s(_vm.currentPurchase.createdAt) + "\n\t\t\t\t                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.status')) + ": \n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n\t\t\t\t                        " + _vm._s(_vm.currentPurchase.purchaseStatus.name) + "\n\t\t\t\t                      ")])])]], 2)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.purchase.view.productsLegend')))]), _vm._v(" "), _c('v-table', {
    attrs: {
      "list": _vm.productList,
      "noDataMessage": _vm.$t('static.purchase.noData'),
      "translation": "static.purchase.products"
    }
  })], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "full-w flex justify-center buttons_under_main_body"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'inventory.purchase.index'
      }
    }
  }, [_c('el-button', {
    staticClass: "dark"
  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.$t('button.receipt').toUpperCase()))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dcffcb8","hasScoped":false}!./src/app/pages/withNavigation/purchase/receipt/receipt.html
// module id = 3077
// module chunks = 1